import React from 'react';

const BlockquoteRenderer = ({
  children,
}: React.DetailedHTMLProps<React.BlockquoteHTMLAttributes<HTMLQuoteElement>, HTMLQuoteElement>) => (
  <blockquote className="my-4 pl-2 border-l-4 border-primary-500 text-neutral-800">{children}</blockquote>
);

export default BlockquoteRenderer;
